import React, { useState } from 'react'
import { Panel, SelectPicker, Input, Row, Col } from 'rsuite'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'

export default function ClosureRequestAssetSearchForm({
  schema,
  loading,
  onSearch = () => {},
  ...props
}) {
  const [assetName, setAssetName] = useState()
  const [assetCode, setAssetCode] = useState()
  const [voucherNumber, setVoucherNumber] = useState()
  const [assetTypeCode, setAssetTypeCode] = useState()
  const [assetStatus, setAssetStatus] = useState()

  const handleSearch = () => {
    var request = {
      assetName: assetName,
      assetCode: assetCode,
      voucherNumber: voucherNumber,
      assetTypeCode: assetTypeCode,
      assetStatus: assetStatus,
    }

    onSearch(request)
  }

  const handleCancel = () => {
    setAssetName('')
    setAssetCode('')
    setVoucherNumber('')
    setAssetTypeCode('')
    setAssetStatus('')

    onSearch({})
  }

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetCode.label}
            <Input
              placeholder={schema.assetCode.hint || schema.assetCode.label}
              value={assetCode}
              onChange={(value) => {
                setAssetCode(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetName.label}
            <Input
              placeholder={schema.assetName.hint || schema.assetName.label}
              value={assetName}
              onChange={(value) => {
                setAssetName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.voucherNumber.label}
            <Input
              placeholder={schema.voucherNumber.hint || schema.voucherNumber.label}
              value={voucherNumber}
              onChange={(value) => {
                setVoucherNumber(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetTypeCode.label}
            <SelectPicker
              searchable={false}
              data={schema.assetTypeCode.options}
              value={assetTypeCode}
              block
              placeholder={`เลือก${schema.assetTypeCode.label || ''}`}
              onChange={(value) => {
                setAssetTypeCode(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetStatus.label}
            <SelectPicker
              searchable={false}
              data={schema.assetStatus.options}
              value={assetStatus}
              block
              placeholder={`เลือก${schema.assetStatus.label || ''}`}
              onChange={(value) => {
                setAssetStatus(value)
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={handleSearch}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
